import React, { Component, Fragment } from 'react'
import { Loader, AsyncButton, Modal, Button, Div, H2, Span } from '@driftt/tide-core'
import { Select } from '@driftt/tide-selects'
import { Table } from '@driftt/tide-table'
import { showTransientNotification } from '@driftt/traffic-control'
import { delay } from 'utils'
import config from 'config'
import axios from 'axios'
import qs from 'querystring'
import { connect } from 'react-redux'
import { pickBy } from 'lodash'
import { pathOr } from 'ramda'

import { getAccessToken } from '@driftt/web-auth'
import { getPeopleInPlaybook, getMeetingAgents, getPersonInPlaybookDetails, unenrollUser } from 'api/playbooks'
import { peopleColumns, filterableMetrics } from 'constants/ReportConstants'
import Paginator from './Paginator'
import RowFormatter from 'components/Reports/EmailPerformance/TableRowFormatter'
import { EmptyTable } from 'components/Reports/EmailPerformance/EmptyState'

import './styles.css'

const LOADING_STATE = {
  hasLoaded: false,
  isLoading: true,
}

class PeopleTab extends Component {
  constructor(props) {
    super(props)

    this.state = {
      size: 20,
      currentPage: 0,
      tableData: null,
      isLoading: true,
      hasLoaded: false,
      pageParams: [],
      page: null,
      metric: { label: 'All Activity', value: null },
      email: null,
      isUnenrolling: false,
      unenrollingEmail: null,
    }
  }

  componentDidMount() {
    this.getEmailPeople()
  }

  componentWillReceiveProps() {
    this.setState({
      hasLoaded: false,
      isLoading: true
    }, this.getEmailPeople)
  }

  getEmailPeople = async () => {
    const { id, dates } = this.props
    const [ startDate, endDate ] = dates
    const { size, page, metric, email } = this.state

    try {
      const { data } = await getPeopleInPlaybook(id, Object.assign({ startDate, endDate, size }, page && {page}, !!metric.value && { metric: metric.value }, !!email && { campaignId: email.value }))
      this.setState({
        tableData: data
      }, this.getEndUsers)
    } catch (error) {
      console.log(error)
    }
  }

  getNumPages = () => {
    const numItems = this.getNumItems()
    const pageSize = this.state.size
    return Math.ceil(numItems/pageSize)
  }

  getNumItems = () => {
    const pageNum = this.state.currentPage + 1
    const pageSize = this.state.size
    const remaining = this.state.tableData.remaining
    const currentPageLength = this.state.tableData.people.length
    return currentPageLength + (pageNum-1)*pageSize + remaining
  }

  getEndUsers = async () => {
    const { tableData } = this.state
    const endUsers = tableData.people.map((endUser) => {
      return endUser.endUserId
    })

    try {
      const { data } = await getPersonInPlaybookDetails(endUsers)
      this.setState({
        endUsers: data
      }, this.getAgents)
    } catch (error) {
      console.log(error)
    }
  }

  getAgents = async () => {
    const { tableData } = this.state

    if (!tableData.people) {
      return
    }

    const agentList = this.getAgentsFromData(tableData.people)

    try {
      const { data } = await getMeetingAgents(agentList)
      this.setState({
        agents: data
      }, this.setHasLoaded)
    } catch (error) {
      console.log(error)
    }
  }

  getAgentsFromData(data) {
    return data
      .filter(user => user.influencedBookedMeeting || user.sentFrom)
      .map(user => [user.influencedBookedMeetingAgentId, user.sentFrom])
      .flatten()
      .filter(id => !!id)
  }

  setHasLoaded = () => {
    const setLoaded = () => {
      this.setState({
        hasLoaded: true
      })
    }

    const setComplete = () => {
      this.setState({
        isLoading: false
      })
    }

    setLoaded()
    delay(setComplete, 500)
  }

  goToNext = () => {
    const { tableData } = this.state
    const { nextPage } = tableData

    this.setState((prevState) => {
      prevState.pageParams.push(nextPage)
      return {
        hasLoaded: false,
        isLoading: true,
        currentPage: prevState.currentPage + 1,
        pageParams: prevState.pageParams,
        page: nextPage
      }
    }, this.getEmailPeople)
  }

  goToPrevious = () => {
    this.setState((prevState) => {
      prevState.pageParams.pop()

      return {
        hasLoaded: false,
        isLoading: true,
        currentPage: prevState.currentPage - 1,
        pageParams: prevState.pageParams,
        page: prevState.pageParams[prevState.pageParams.length - 1]
      }
    }, this.getEmailPeople)
  }

  setPageSize = ({ value }) => (
    this.setState({
      size: value,
      currentPage: 0,
      page: null,
      pageParams: [],
      hasLoaded: false,
      isLoading: true
    }, this.getEmailPeople)
  )

  unenrollUserApi = async (person) => {
    try {
      await unenrollUser(person)
      this.props.notify('User successfully unenrolled!')
    } catch (e) {
      this.props.notify('Could not unenroll, please try again later', 'error')
      console.log(e)
    }
  }

  unenrollUser = (person) => {
    this.setState({
      isUnenrolling: true,
      unenrollingPerson: person,
    })
  }

  onUnenrollClick = () => {
    const { unenrollingPerson } = this.state

    this.unenrollUserApi(unenrollingPerson)

    this.setState({
      isUnenrolling: false,
      unenrollingPerson: null
    })
  }

  onCancelClick = () => {
    this.setState({
      isUnenrolling: false,
      unenrollingPerson: null
    })
  }


  getCSVPromise = () => {
    const { id, dates, notify } = this.props
    const { metric, email } = this.state
    const [ startDate, endDate ] = dates

    const getCSV = async () => {
      const queryParams = {
        startDate,
        endDate,
        metric: metric.value,
        access_token: getAccessToken(),
        campaignId: !!email && email.value,
      }
      return axios.get(`${config.CONVERSATION_API}/playbooks/${id}/people_tab/csv/v2/?${qs.stringify(pickBy(queryParams))}`)
        .then((res) => {
          notify("Success! You should receive an email within 10 minutes with a direct download link!")
        })
        .catch((err) => {
          // TODO: capture exceptions on 400
          notify('Something went wrong when sending you an email with a direct download link', 'error')
        })
    }

    return getCSV
  }

  handleMetricFilterChange = (option) => {
    if (!!option) {
      this.setState({ metric: option, ...LOADING_STATE }, this.getEmailPeople)
    } else {
      this.setState({ metric: { label: 'All Activity', value: null }, ...LOADING_STATE }, this.getEmailPeople)
    }
  }

  handleEmailFilterChange = (option) => {
    if (!!option) {
      this.setState({ email: option, ...LOADING_STATE }, this.getEmailPeople)
    } else {
      this.setState({ email: null, metric: { label: 'All Activity', value: null }, ...LOADING_STATE }, this.getEmailPeople)
    }
  }

  makeEmailFilterOptions() {
    const playbook = this.props.playbook
    const emails = playbook.actions[0].action.emails
    return emails.map((email, index, { length: numEmails }) => (
      {
        value: email.campaignId,
        label: numEmails > 1 ? `Email ${index + 1} : ${email.title}` : email.title,
      }
    ))
  }

  renderTableOrEmptyState() {
    const { tableData, endUsers, agents } = this.state
    const { people } = tableData
    const noPeople = people.length === 0
    const { playbook } = this.props
    return (
      <Fragment>
        {noPeople ? 
          <Div className="reports-people-no-matches">
            <EmptyTable />
            <H2>No results matching your filters</H2>
          </Div> :        
          <Div className="reports-people-table-container horizontal-mask">
            <Table 
                className="reports-people-table" 
                width="2250px"
                columns={peopleColumns}
                data={!!tableData ? people.map((person) => RowFormatter.PeopleRows(person, endUsers, agents, playbook, this.unenrollUser)) : []}
            />
          </Div>
        }
      </Fragment>
    )
  }

  render() {
    const {
      isLoading,
      hasLoaded,
      size,
      currentPage,
      metric,
      email,
      isUnenrolling,
      unenrollingPerson,
    } = this.state

    if (hasLoaded && !email) {
      this.setState({
        email: this.makeEmailFilterOptions()[0]
      })
    }

    return (
      <Div className="playbooks-report-people">
        {isLoading &&
          <Div className="playbook-report-loader">
            <Loader height={200} width={200} />
          </Div>
        }
        {hasLoaded &&
          <Fragment>
            <Div className="reports-people-header">
              <Div className="reports-people-header-total-count">
                <Span>{`${this.getNumItems()} People`}</Span>
                <Span className="reports-people-header-selects">
                  {email &&
                    <Select
                      className="reports-people-select-metric"
                      value={metric}
                      onChange={this.handleMetricFilterChange}
                      isClearable={false}
                      options={Object.entries(filterableMetrics).map(([key, value]) => ({ value, label: key }))}
                    />
                  }
                  <Select
                    className="reports-people-select-email"
                    placeholder="Filter by email..."
                    value={email}
                    onChange={this.handleEmailFilterChange}
                    options={this.makeEmailFilterOptions()}
                    isClearable={false}
                  />
                  <AsyncButton promise={this.getCSVPromise()} type="tertiary">Email me a CSV</AsyncButton>
                </Span>
              </Div>
            </Div>
            {this.renderTableOrEmptyState()}
          </Fragment>
        }
        {hasLoaded &&
          <Paginator size={size} index={currentPage} totalPages={this.getNumPages()} changeSize={this.setPageSize} goForward={this.goToNext} goBackward={this.goToPrevious} />
        }
        {isUnenrolling &&
          <Modal
            open={ true }
            title={`Are you sure you want to unenroll ${unenrollingPerson ? unenrollingPerson.email: ''}?`}
            type="warning"
            size="small"
            onClose={this.onCancelClick}
            className="playbook-unenroll-modal"
            footerCopy={
              <>
                <Button
                  type="secondary"
                  size="medium"
                  onClick={this.onUnenrollClick}
                >
                  Unenroll
                </Button>
                <Button
                  type="tertiary"
                  onClick={this.onCancelClick}
                >
                  Cancel
                </Button>
              </>
            }
            >
            {pathOr('This person', ['name'], unenrollingPerson)} will no longer receive emails in this campaign. This action cannot be undone.
          </Modal>
        }
      </Div>
    )
  }
}

const mapDispatchToProps = dispatch => {
  return {
    notify: (message, type = 'success') => dispatch(showTransientNotification({ message, type }))
  }
}

export default connect(null, mapDispatchToProps)(PeopleTab)
